module.exports = __webpack_public_path__ + "img/CtrlRoom_vol_3.0f372d9a.png";